import { splitDomain } from "@/lib/domain"

/**
 * A domain name, with the TLD in the accent colour.
 *
 * The accent on the TLD is the product's one visual signature, carried over from
 * the sign-in screen so both halves read as the same thing. Set in the body face
 * at medium weight and tight tracking: no monospace family is loaded here, so
 * `font-mono` would fall back to an undesigned system stack - and it renders
 * Cyrillic inconsistently.
 */
export default function DomainName({ domain, className = '', size = 'base' }: { domain: string, className?: string, size?: 'sm' | 'base' | 'lg' }) {
  const { name, tld } = splitDomain(domain)
  const sizes = { sm: 'text-sm', base: 'text-base', lg: 'text-lg sm:text-xl' }

  return (
    <span className={`font-medium tracking-tight break-all ${sizes[size]} ${className}`}>
      {name}<span className="text-blue">{tld}</span>
    </span>
  )
}
